import { axios } from 'libs';

const resource = '/processo-andamentos';

export const save = (id, andamento) => {
  if (andamento.id) {
    return axios.put(`${resource}/${andamento.id}${id}`, andamento);
  }

  return axios.post(`${resource}/${id}`, andamento);
};

export const deleteById = id => {
  return axios.delete(`${resource}/${id}`);
};
